<div *ngIf="!isValidObj()">
  <p style="background-color: coral">Object is invalid!</p>
</div>
